import {createSlice} from "@reduxjs/toolkit";
import {ASSET_IDS} from "../util/asset-ids.js";
import dayjs from "dayjs";
import {getStorage, setStorage} from "../api/_token.js";

export const NAME = 'comparator';

const initialState = {
    datetime: undefined,
    value: undefined,
    assetId1: getStorage('comparator-asset-1', ASSET_IDS.RETH),
    assetId2: getStorage('comparator-asset-2', ASSET_IDS.BTC),
    maxDuration: getStorage('comparator-max-duration', 31),
    isActive: false,
    deltaPercent: 0,
    asset1ChangePct: 0,
    firstDate: dayjs().format('YYYY-MM-DD'),
    pairStorage: getStorage('comparator-pair-storage', []),
    annotationId: null,
    startDate: null,
}

const {actions, reducer} = createSlice({
    name: NAME,
    initialState,
    reducers: {
        setAssetId1: (state, {payload}) => {
            setStorage('comparator-asset-1', payload)
            state.assetId1 = payload
        },
        setAssetId2: (state, {payload}) => {
            setStorage('comparator-asset-2', payload)
            state.assetId2 = payload
        },
        setDuration: (state, {payload}) => {
            setStorage('comparator-max-duration', payload)
            state.maxDuration = payload
            state.annotationId = null
            state.startDate = null
        },
        setAnnotation: (state, {payload: {id, startDate}}) => {
            state.annotationId = id
            state.startDate = startDate
        },
        setDeltaPercent: (state, {payload}) => {
            state.deltaPercent = payload
        },
        setAsset1ChangePct: (state, {payload}) => {
            state.asset1ChangePct = payload
        },
        setFirstDate: (state, {payload}) => {
            state.firstDate = payload
        },
        setStorePair: state => {
            const pairStorage = [
                [state.assetId1, state.assetId2],
                ...state.pairStorage,
            ].slice(0, 6)
            setStorage('comparator-pair-storage', pairStorage)
            state.pairStorage = [...pairStorage]
        },
        removeStoredPair: (state, {payload}) => {
            const pairStorage = state.pairStorage.filter((_, idx) => idx !== payload)
            setStorage('comparator-pair-storage', pairStorage)
            state.pairStorage = pairStorage
        },
        reset: () => ({
            ...initialState
        }),
    }
})

export const {
    setAssetId1,
    setAssetId2,
    setDuration,
    setAnnotation,
    setDeltaPercent,
    setAsset1ChangePct,
    setFirstDate,
    setStorePair,
    removeStoredPair,
} = actions

const getState = state => state[NAME]

export const getAssetId1 = state => getState(state).assetId1
export const getAssetId2 = state => getState(state).assetId2
export const getValue = state => getState(state).value
export const getMaxDuration = state => getState(state).maxDuration
export const getDeltaPercent = state => getState(state).deltaPercent
export const getAsset1ChangePct = state => getState(state).asset1ChangePct
export const getFirstDate = state => getState(state).firstDate
export const getPairStorage = state => getState(state).pairStorage
export const getAnnotationId = state => getState(state).annotationId
export const getStartDate = state => getState(state).startDate


// export const getLiveChartHoverValues = (state, assetId) => getAssetId(state) !== assetId ? [] : [getValue(state), getDatetime(state)]
// export const getIsLiveChartActive = (state, assetId) => getAssetId(state) === assetId && getIsActive(state)

export default reducer